import { sample } from '@sama/micro-dash';
import { Answer } from '../../team-apis/otterdam/answers/answer';
import { DropdownOutput } from '../../team-apis/otterdam/outputs/dropdown-output';
import { OutputHelper } from './output-helper';

export class DropdownOutputHelper extends OutputHelper<DropdownOutput> {
  override supportsDefaultAnswer = true;

  override getLabelFor(
    answer: Answer | undefined,
    output: DropdownOutput,
  ): string {
    return this.getMatchingAnswerOptionLabel(answer, output);
  }

  override makeRandomAnswer(output: DropdownOutput) {
    return sample(output.answer_options).name;
  }
}
